(() => {
  const Northyard = window.Northyard = window.Northyard || {};

  Northyard.rootUrl = (document.body.dataset.rootUrl || '/').replace(/\/$/, '');
  Northyard.moneyFormat = document.body.dataset.moneyFormat || '${{amount}}';
  Northyard.qs = (selector, context = document) => context.querySelector(selector);
  Northyard.qsa = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  Northyard.path = (path) => Northyard.rootUrl + '/' + String(path).replace(/^\//, '');
  Northyard.html = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
  Northyard.normalize = (value = '') => String(value).toLowerCase().replace(/[^a-z0-9]/g, '');
  Northyard.colorCss = (value = '') => {
    const colors = {
      black: '#111315',
      white: '#f7f7f5',
      navy: '#172a46',
      orange: '#d96b2b',
      royalblue: '#2459a9',
      skyblue: '#73b9e6',
      seablue: '#3b88a8',
      federalblue: '#243c7a',
      blue: '#3979bf',
      blueheather: '#6f91ae',
      greyblue: '#718494',
      coolgrey: '#9da6aa',
      darkgrey: '#4c5155',
      grey: '#85898b',
      gray: '#85898b',
      greyheather: '#9c9fa1',
      lightgrey: '#d6d8d8',
      smokegrey: '#737b7f',
      coffee: '#6b4d3b',
      khaki: '#a99976',
      lodenfrost: '#68715b',
      armygreen: '#59634c',
      winered: '#7d2938',
      red: '#a72e36'
    };
    return colors[Northyard.normalize(value)] || '#d9e5ef';
  };
  Northyard.formatMoney = (cents, format = Northyard.moneyFormat) => {
    const value = Number(cents || 0);
    const delimit = (number, precision = 2, thousands = ',', decimal = '.') => {
      const parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? parts.join(decimal) : parts[0];
    };
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return delimit(value);
    let amount = delimit(value);
    if (match[1] === 'amount_no_decimals') amount = delimit(value, 0);
    if (match[1] === 'amount_with_comma_separator') amount = delimit(value, 2, '.', ',');
    if (match[1] === 'amount_no_decimals_with_comma_separator') amount = delimit(value, 0, '.', ',');
    return format.replace(match[0], amount);
  };
  Northyard.discountLabel = (price, compareAt) => {
    if (!compareAt || compareAt <= price) return '';
    const discount = ((compareAt - price) / compareAt) * 100;
    return discount.toFixed(1).replace(/\.0$/, '') + '% OFF';
  };
  const analyticsFields = {
    quick_view_open: ['product_id', 'product_handle', 'location', 'source'],
    color_select: ['product_id', 'color', 'location'],
    size_select: ['product_id', 'size', 'location'],
    carousel_interaction: ['product_id', 'type', 'direction', 'location'],
    size_guide_open: ['product_id', 'location', 'source'],
    cart_item_edit: ['variant_id']
  };
  let privacyLoading = false;
  let privacyAttempts = 0;
  const preparePrivacy = () => {
    if (window.Shopify?.customerPrivacy || privacyLoading || privacyAttempts >= 2 || !window.Shopify?.loadFeatures) return;
    privacyLoading = true;
    privacyAttempts += 1;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { privacyLoading = false; });
    } catch (_) { privacyLoading = false; }
  };
  Northyard.emit = (name, detail = {}) => {
    if (!Object.hasOwn(analyticsFields, name)) return false;
    preparePrivacy();
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return false;
    } catch (_) { return false; }
    const safeDetail = {};
    for (const key of analyticsFields[name]) {
      const value = detail?.[key];
      if (typeof value === 'string' && value.length <= 120) safeDetail[key] = value;
      else if (typeof value === 'number' && Number.isFinite(value)) safeDetail[key] = value;
    }
    window.dispatchEvent(new CustomEvent('northyards:' + name, { detail: safeDetail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, safeDetail));
    return true;
  };
  preparePrivacy();
  window.addEventListener('load', preparePrivacy, { once: true });
  Northyard.openDialog = (dialog, opener) => {
    if (!dialog) return;
    dialog._northyardsOpener = opener || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('is-overlay-open');
  };
  Northyard.closeDialog = (dialog, restoreFocus = true) => {
    if (!dialog || !dialog.open) return;
    const opener = dialog._northyardsOpener;
    dialog.close();
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('is-overlay-open');
    if (restoreFocus && opener instanceof HTMLElement && opener.isConnected) {
      opener.focus({ preventScroll: true });
    }
  };
  Northyard.mediaColor = (alt = '') => {
    const descriptive = String(alt).match(/color\s*:\s*([^|#]+)/i);
    if (descriptive) return descriptive[1].trim();
    const legacy = String(alt).match(/#color[_:\s-]*([^|#]+)/i);
    return legacy ? legacy[1].trim() : '';
  };
  Northyard.mediaForColor = (media = [], color = '', featuredMediaId = null) => {
    const wanted = Northyard.normalize(color);
    if (!wanted) return media;
    const matched = media.filter((item) => Northyard.normalize(Northyard.mediaColor(item.alt)) === wanted);
    if (matched.length) return matched;
    if (featuredMediaId) {
      const featured = media.find((item) => String(item.id) === String(featuredMediaId));
      if (featured) return [featured];
    }
    return media.length === 1 ? media : [];
  };
  document.addEventListener('click', (event) => {
    const menuOpen = event.target.closest('[data-mobile-menu-open]');
    if (menuOpen) Northyard.openDialog(Northyard.qs('[data-mobile-menu]'), menuOpen);
    const close = event.target.closest('[data-overlay-close]');
    if (close) Northyard.closeDialog(close.closest('dialog'));
    if (event.target instanceof HTMLDialogElement) Northyard.closeDialog(event.target);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDialogs = Northyard.qsa('dialog[open]');
    const topDialog = openDialogs[openDialogs.length - 1];
    if (!topDialog) return;
    event.preventDefault();
    Northyard.closeDialog(topDialog);
  });
  Northyard.qsa('dialog').forEach((dialog) => {
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('is-overlay-open');
    });
  });

  let header;
  let announcementObserver;
  const mobileHeader = window.matchMedia('(max-width: 989px)');
  let previousScroll = window.scrollY;
  const initHeader = () => {
    announcementObserver?.disconnect();
    header = Northyard.qs('[data-site-header]');
    if (!header) return;
    header.classList.remove('is-hidden');
    header.classList.toggle('is-scrolled', window.scrollY > 8);
    const section = header.closest('.shopify-section');
    const announcement = section?.querySelector('.announcement-bar');
    const measure = () => section?.style.setProperty('--ny-announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);
    measure();
    if (announcement) {
      announcementObserver = new ResizeObserver(measure);
      announcementObserver.observe(announcement);
    }
    previousScroll = window.scrollY;
  };
  initHeader();
  document.addEventListener('shopify:section:load', initHeader);
  document.addEventListener('shopify:section:unload', (event) => {
    if (!header || !event.target.contains(header)) return;
    announcementObserver?.disconnect();
    header = null;
    if (!document.querySelector('dialog[open]') || [...document.querySelectorAll('dialog[open]')].every(dialog => event.target.contains(dialog))) {
      document.body.classList.remove('is-overlay-open');
    }
  });
  const showHeader = () => header?.classList.remove('is-hidden');
  mobileHeader.addEventListener('change', showHeader);
  document.addEventListener('focusin', (event) => {
    if (header?.contains(event.target)) showHeader();
  });
  window.addEventListener('scroll', () => {
    const current = window.scrollY;
    if (header) {
      header.classList.toggle('is-scrolled', current > 8);
      const canHide = header.classList.contains('site-header--sticky') && mobileHeader.matches
        && !document.body.classList.contains('is-overlay-open') && !header.contains(document.activeElement);
      header.classList.toggle('is-hidden', canHide && current > previousScroll && current > 150);
    }
    previousScroll = Math.max(0, current);
  }, { passive: true });
})();
